<div class="kpi-card">
	<div class="kpi-card__header">
		<typography variant="p/xxs_semibold" class="kpi-card__label">
			{{ label }}
		</typography>
		<app-icon
			*ngIf="showInfo"
			class="kpi-card__info"
			type="svg"
			[size]="14"
			color="#888"
			[label]="infoTooltip ?? undefined"
			[matTooltip]="infoTooltip ?? ''"
			matTooltipPosition="above"
		>
			info_circle
		</app-icon>
	</div>
	<typography variant="p/lg_medium" class="kpi-card__value">
		{{ displayValue }}
	</typography>
	<typography
		*ngIf="change !== null"
		variant="p/base_regular"
		class="kpi-card__change"
		[class.kpi-card__change--positive]="good === true"
		[class.kpi-card__change--negative]="good === false"
	>
		{{ changeLabel }}
	</typography>
	<typography
		*ngIf="change === null && description !== null"
		variant="p/base_regular"
		class="kpi-card__change kpi-card__change--positive"
	>
		{{ description }}
	</typography>
</div>
